<template>
  <div class="newwarp boxsizing miniwarp gray80">
    <div class="auto">
      <page-title title="概览" icon="fa-user-circle"></page-title>
    </div>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" :notitle="true" v-loading="loading">
            <div slot="content">
              <el-row align="middle">
                <el-col :span="6" align="center" class="benchmarkbox">
                  <p class="font30">当前用户总数</p>
                  <span class="font30">
                    {{util.numberFormat(summary['total_fans_sub'] || 0)}}
                  </span>
                </el-col>
                <el-col :span="18" style="border-left:1px solid #ccc;">
                  <div class="auto flex-box">
                    <div class="benchbox benchbox1">
                      累计新增人数
                      <el-tooltip class="item" effect="dark" content="公众号开通至今，累计用户关注总数，包含已取关用户。" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(summary['total_user'] || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox2">
                      累计取关人数
                      <el-tooltip class="item" effect="dark" content="公众号介入平台后至今，累计取关人数总和。" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(summary['total_fans_unsub'] || 0)}}</p>
                    </div>
                    <div class="benchbox benchbox3">
                      当前可触达人数
                      <el-tooltip class="item" effect="dark" content="48小时内给公众号发过消息，可发客服消息的人数。" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(summary['user_48'] || 0)}}</p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="关注来源 " tooltip="通过二维码关注的粉丝总数及取关人数占比。" v-loading="tableLoading">
            <div slot="content">
              <el-row>
                <el-col :span="8">
                  <echarts :data="chartData1" title="" height="300" :nohader="true"></echarts>
                </el-col>
                <el-col :span="16">
                  <el-table :data="userScene['qr_scene']" style="width: 100%;margin-bottom: 20px;">
                    <el-table-column prop="name" label="来源">
                    </el-table-column>
                    <el-table-column prop="total" sortable label="总数" width="150">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.total)}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="unsub" sortable width="150" label="取关数">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.unsub)}}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="关注方式 " tooltip="各渠道关注的粉丝总数及取关人数占比，可直观查看整体粉丝来源渠道的质量，便于运营策略的制定及调整。" v-loading="tableLoading">
            <div slot="content">
              <el-row>
                <el-col :span="8">
                  <echarts :data="chartData2" title="" height="300" :nohader="true"></echarts>
                </el-col>
                <el-col :span="16">
                  <el-table :data="userScene['subscribe_scene']" style="width: 100%;margin-bottom: 20px;">
                    <el-table-column prop="name" label="方式">
                    </el-table-column>
                    <el-table-column prop="total" sortable label="总数" width="150">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.total)}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="unsub" sortable width="150" label="取关数">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.unsub)}}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Data as DataModel } from '@/model'
import { Data as DataController } from '@/controller'
export default {
  data () {
    return {
      loading: false,
      summary: {
      },
      tableLoading: false,
      chartData1: {},
      chartData2: {},
      userScene: {}
    }
  },
  methods: {
    async getOverviewSummary () {
      this.loading = true
      let res = await DataModel.User.getUserTotal()
      if (!res['err_code']) {
        this.summary = res['data']
      }
      this.loading = false
    },
    async getUserSceneTotal () {
      this.tableLoading = true
      let res = await DataModel.User.getUserSceneTotal({size:7})
      if (!res['err_code']) {
        this.userScene = res['data']
        let chart1 = ''
        let chart2 = ''
        if (res['data']['qr_scene'] && res['data']['qr_scene'].length) {
          chart1 = {}
          res['data']['qr_scene'].map(item => {
            chart1[item['name']] = item['total']
          })
        }
        if (res['data']['subscribe_scene'] && res['data']['subscribe_scene'].length) {
          chart2 = {}
          res['data']['subscribe_scene'].map(item => {
            chart2[item['name']] = item['total']
          })
        }
        this.chartData1 = DataController.User.overviewPie(chart1 || '')
        this.chartData2 = DataController.User.overviewPie(chart2 || '')
      }
      this.tableLoading = false
    }
  },
  created () {
    this.getOverviewSummary()
    this.getUserSceneTotal()
    // this.getOverviewBaseInfo()
    // this.getOverviewDeviceInfo()
    // this.getOverviewBaseInfoQrsence()
  },
  mounted () {
  }
}
</script>
<style scoped>
.benchmarkbox {
  padding-right: 20px;
}
.benchmarkbox p {
  color: #ef8e2f;
  margin: 35px 0 30px;
}
.benchbox {
  flex: 1;
  margin: 0 30px 30px;
  padding: 30px 0;
  border-bottom: 2px solid #ef8e2f;
  text-align: center;
}
.benchbox2 {
  border-color: #6cb12c;
}
.benchbox3 {
  border-color: #39a6fc;
}
.benchbox4 {
  border-color: #58e1c2;
}
.benchbox5 {
  border-color: #b961fc;
}
.benchbox p {
  font-size: 30px;
  font-weight: 300;
  margin-top: 30px;
}

.usercountbox {
  padding-right: 30px;
}
.usercountbox p {
  margin: 85px 0 50px;
}
.usercountbox span {
  font-weight: 300;
}
.nobor {
  border: none;
  margin-bottom: 0px;
}

.useraddbox {
  flex: 1;
}
.useraddbox p {
  font-size: 30px;
  font-weight: 300;
  padding: 20px 0 30px;
}
.nopadbotbox .useraddbox p {
  padding-bottom: 0;
}
.morep {
  text-align: right;
}
</style>
